import Vue from 'vue';
import 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';

import basketMixin from '../core/basket'
import accordionSection from '../components/accordion-section'
import cityAutocomplete from '../components/city-autocomplete'
import streetAutocomplete from '../components/street-autocomplete'

Vue.component('accordion-section', accordionSection);
Vue.component('city-autocomplete', cityAutocomplete);
Vue.component('street-autocomplete', streetAutocomplete);

var mainVM = new Vue({
    mixins: [basketMixin],
    el: '#mainApp',
    data: {
        currentSection: getParameterByName("section") != "" ? getParameterByName("section") : "checkout-customer",
        pageErrors: [],
        customerModel: window.customerModel,
        shippingAddressModel: window.shippingAddressModel,
        shippingMethodModel: window.shippingMethodModel,
        paymentMethodType: window.paymentMethodType
    },
    mounted: function () {
        var vm = this;
        window.onpopstate = function (e) {
            if (vm.basket.items.length == 0) {
                window.location = "/basket";
            }
            var section = "checkout-customer";
            if (e.state != null) {
                section = e.state.section;
            }
            vm.currentSection = section;
        };
    },
    methods: {
        setCurrentSection: function (section) {
            this.currentSection = section;
            window.history.pushState({ section: section }, section, "?section=" + section);
        },
        saveCustomer: function (e) {
            var vm = this;
            vm.postSection("checkout-customer",
                "/checkout/savecustomer",
                $(e.currentTarget),
                function (response) {
                    vm.shippingAddressModel = response.shippingAddressModel;
                }
            );
        },
        saveShippingAddress: function (e) {
            var vm = this;
            vm.postSection("shipping-address",
                "/checkout/saveshippingaddress",
                $(e.currentTarget),
                function (response) {
                    if (vm.selectedShippingMethod != null && vm.selectedShippingMethod.shippingOption.id > 0 && vm.selectedShippingMethod.shippingOption.shippingCity != vm.shippingAddressModel.city) {
                        vm.getBasket(vm.selectedShippingMethod.shippingOption.id, function () {
                            document.dispatchEvent(new Event("mod:ShippingAddressSaved"));
                        });
                    }
                    else
                        document.dispatchEvent(new Event("mod:ShippingAddressSaved"));
                    vm.shippingMethodModel = response.shippingMethodModel;
                    window.shippingMethodModel = vm.shippingMethodModel;
                }
            );
        },
        saveShippingMethod: function (e) {
            var vm = this;
            vm.postSection("shipping-method",
                "/checkout/saveshippingmethod",
                $(e.currentTarget),
                function (response) {
                }
            );
        },
        placeOrder: function (e) {
            var vm = this;
            vm.postSection("checkout-payment",
                "/checkout/placeorder",
                $(e.currentTarget),
                function (response) {
                }
            );
        },
        selectShippingMethod: function (shippingMethod) {
            var vm = this;
            if (vm.selectedShippingMethod != null) {
                vm.selectedShippingMethod.selected = false;
            }
            shippingMethod.selected = true;
            vm.getBasket(shippingMethod.shippingOption.id, function () {
                if (shippingMethod.shippingOption.id > 0)
                    document.dispatchEvent(new CustomEvent("mod:shippingMethodSelected", { 'detail': vm.selectedShippingMethod }));
            });
        },
        postSection: function (name, url, btn, success) {
            var vm = this;
            var $form = $('#' + name);
            if (!btn.buttonIsWaiting() && $form.valid()) {
                btn.buttonWait();
                vm.pageErrors = "";
                $.post({
                    url: vm.URLPrefix + url,
                    data: $form.serialize(),
                    success: function (response) {
                        if (response.redirect != undefined && response.success == 1) {
                            window.location = response.redirect;
                        } else if (response.errors != undefined && response.errors.length > 0) {
                            vm.pageErrors = response.errors;
                        } else if (response.gotoSection != undefined) {
                            vm.setCurrentSection(response.gotoSection);
                        }
                        if (success != undefined) {
                            success(response);
                        }
                    }
                }).done(function (response) {
                    btn.buttonStopWaiting();
                });
            }
        }
    },
    computed: {
        selectedShippingMethod: function (val) {
            var vm = this;
            if (vm.shippingMethodModel != null && vm.shippingMethodModel.shippingMethods != null) {
                var selectedShippingMethod = vm.shippingMethodModel.shippingMethods.filter(function (item) { return item.selected; });
                if (selectedShippingMethod.length > 0) {
                    return selectedShippingMethod[0];
                }
            }
            return null;
        },
        // סינון סניפים לפי שיטת המשלוח הנבחרת
        filteredBranches: function () {
            var vm = this;
            var allBranches = window.allBranches || [];
            
            if (vm.selectedShippingMethod == null || vm.selectedShippingMethod.shippingOption == null) {
                return allBranches;
            }
            
            var selectedShippingMethodId = vm.selectedShippingMethod.shippingOption.id;
            
            // סינון סניפים לפי ShippingMethodId - מציג סניפים שמשויכים לשיטת המשלוח הנבחרת או שאין להם שיוך (תאימות לאחור)
            return allBranches.filter(function (branch) {
                return branch.shippingMethodId == null || branch.shippingMethodId == selectedShippingMethodId;
            });
        }
    }
});






function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

(function ($) {
    $.fn.extend({
        validateField: function (w, msg) {
            if (checkFieldValue(w, $(this).attr('value'), $(this).attr('placeholder'))) {
                if ($(this).parent().children('.msg').length === 0) {
                    $(this).parent().addClass('error');
                    $(this).parent().append('<span class="msg"><p>' + msg + '</p></span>');
                }
                return true;
            } else {
                $(this).parent().removeClass('error');
                $(this).parent().children('.msg').remove();
                return false;
            }
        },
        buttonWait: function () {
            if ($(this).length == 0)
                return;

            if ($(this).prop("tagName") === 'INPUT')
                $(this).addClass('preloader');

            else {
                $(this).attr('data-html', $(this).html().trim());
                $(this).css({ width: $(this).outerWidth() });
                $(this).html('<span class="btn-preloader"></span>');
            }
            $(this).attr('waiting', 'true');
        },
        buttonStopWaiting: function () {
            if ($(this).length == 0)
                return;

            if ($(this).attr('data-html') !== '')
                $(this).html($(this).attr('data-html'));

            $(this).attr('waiting', 'false');
            $(this).removeClass('preloader');
        },
        buttonIsWaiting: function () {
            if ($(this).length == 0)
                return;
            return $(this).attr('waiting') === 'true';
        }
    });
})(jQuery);